import { useEffect, useRef, useState, useMemo } from '../../common/common';
import axiosJWT from '../../secureAPI/axiosJWT';
import { showToast } from '../../Utils/toastUtils';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { useErrorContext } from '../../context/ErrorContext';
import useNavigation from '../../common/useNavigation';
import useGetUserData from '../../secureAPI/GetUserData';
import { validateAddPriceListForm } from '../../validation/Authentication/Validation';

const MidPriceList = (type) => {
    const { navigateDashboard } = useNavigation();
    const { users } = useGetUserData();
    const { setValidationError, clearAllErrors } = useErrorContext();
    const [isDisabled, setisDisabled] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [showEditPriceListModal, setShowEditPriceListModal] = useState(false);
    const [priceListType, setPriceListType] = useState('state');
    const [allPriceData, setAllPriceData] = useState({
        state: [],
        distributor: []
    });
    const [editID, setEditID] = useState(0);
    const [filteredData, setFilteredData] = useState([]);
    const [distributors, setDistributors] = useState([]);
    const [countryData, setCountryData] = useState([]);
    const [stateData, setStateData] = useState([]);
    const [productVariants, setProductsVariant] = useState([]);
    const [products, setProducts] = useState([]);
    const [isIndian, setisIndian] = useState(null);
    const [values, setvalue] = useState({
        priceListType: 'state',
        country: null,
        state: null,
        distributor: null,
        productId: null,
        variantId: null,
        price: '',
        distributorName: null,
    });
    useEffect(() => {
        const fetchData = async () => {
            showToast('', '');
            if (Array.isArray(users) && users.length > 0) {
                const currentUser = users[0];
                const userTypes = currentUser['UserType'];
                const usertypeArray = typeof userTypes === 'string'
                    ? userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num))
                    : [];
                const hasOne = usertypeArray.includes(1);
                const hasTwo = usertypeArray.includes(2);
                const isPersonal = currentUser['IsPersonalDetils'] === 1;
                if (type === 'seller' && isPersonal && hasOne && hasTwo) {
                   
                    StopLoading(setisLoading);
                } else {
                    navigateDashboard('buyer');
                }

                
            }
        };

        fetchData().catch(error => {

            StopLoading(setisLoading);
        });
    }, [users, type]);

    const handleChange = (value) => {
        setPriceListType(value);
    }

    const handleShowEditModal = (id, pricelistby) => {
        setShowEditPriceListModal(true);
        setEditID(id);
        alert(pricelistby)
        if (pricelistby === 'state') {
            // Find the state data from allPriceData.state
            const stateItem = allPriceData.state.find(item => item.id === id);

            if (stateItem) {
                setvalue(prevValues => ({
                    ...prevValues,
                    priceListType: 'state',
                    state: {
                        value: stateItem.state_id,
                        label: stateItem.state_name
                    },
                    price: stateItem.price,
                    productId: stateItem.product_variant_id,
                    variantId: stateItem.product_variant_id,
                    variant: stateItem.product_variant,
                    product: stateItem.product_name
                }));
            }
        }
        else if (pricelistby === 'distributor') {
            // Find the distributor data from allPriceData.distributor
            const distributorItem = allPriceData.distributor.find(item => item.id === id);
            // console.log({ distributorItem: distributorItem });
            if (distributorItem) {
                setvalue(prevValues => ({
                    ...prevValues,
                    priceListType: 'distributor',
                    distributor: {
                        value: distributorItem.distributor_id,
                        label: distributorItem.distributor_id.toString() // Convert to string if needed
                    },
                    price: distributorItem.price,
                    productId: distributorItem.product_variant_id,
                    variantId: distributorItem.product_variant_id,
                    variant: distributorItem.product_variant,
                    product: distributorItem.product_name,
                    distributorName: distributorItem.full_name
                }));
            }
        }
    };
    const handleCloseEditModal = () => setShowEditPriceListModal(false);

    // Fetch all price list data when component mounts
    useEffect(() => {
        getPriceList();
    }, []);

    // Update filtered data when priceListType or search changes
    useEffect(() => {
        const filterData = () => {
            const data = priceListType === 'state' ? allPriceData.state : allPriceData.distributor;

            if (!search) {
                setFilteredData(data);
                return;
            }

            const filtered = data.filter(item => {
                return (
                    (item.product_variant_id && item.product_variant_id.toLowerCase().includes(search.toLowerCase())) ||
                    (item.price && item.price.toString().includes(search)) ||
                    (item.state_name && item.state_name.toLowerCase().includes(search.toLowerCase())) ||
                    (item.distributor_name && item.distributor_name.toLowerCase().includes(search.toLowerCase())) ||
                    (item.created_at && new Date(item.created_at).toLocaleDateString().includes(search)) ||
                    (item.updated_at && new Date(item.updated_at).toLocaleDateString().includes(search))
                );
            });

            setFilteredData(filtered);
        };

        filterData();
    }, [search, priceListType, allPriceData]);

    const validateAndSetErrors = (values) => {
        const validationErrors = validateAddPriceListForm(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };


    const getPriceList = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetProductPricelist`,
                { priceListType: 'all' }, // Request all data at once
                { withCredentials: true }
            )
                .then((response) => {
                    StopLoading(setisLoading);
                    if (response.data.success === 1) {
                        setAllPriceData({
                            state: response.data.statedata || [],
                            distributor: response.data.distributordata || []
                        });
                    } else {
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    const res_status = err.response?.data?.success;
                    const res_message = err.response?.data?.message;
                    if (res_status !== "" && res_message !== "") { }
                    else if (err.status === 401) {
                        // logout();
                    }
                    else {
                        showToast(err.data?.message || 'An error occurred', 'error');
                    }
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to fetch price list data", 'error');
        }
    };

    const deletePriceList = async (delete_id, priceListType) => {
        if (window.confirm("Are you sure you want to delete Price?")) {
            StartLoading(setisLoading);
            try {
                await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/DeleteProductPricelist`,
                    { delete_id, priceListType, app: 0 },
                    { withCredentials: true }
                )
                    .then((res) => {
                        if (res.data.success === 1) {
                            showToast(res.data.message, 'success');
                            getPriceList(); // Refresh the data
                        } else {
                            showToast(res.data.message, 'error');
                        }
                    })
                    .catch((err) => {
                        showToast('Something went wrong! Please try later', 'error');
                    });
            } catch (err) {
                StopLoading(setisLoading);
                showToast('An error occurred', 'error');
            }
        }
    }

    const handleProductPriceListSubmit = () => {
        EditProductPriceListSubmit();
    }
    const EditProductPriceListSubmit = async () => {
        StartLoading(setisLoading);
        if (!editID || !values.price) {

        }
        else {
            // If all validations pass, make API call
            try {
                const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/EditProductPricelist`, { values, editID, app: 0 }, { withCredentials: true });

                StopLoading(setisLoading);
                if (response.data.success === 1) {
                    showToast(response.data.message, 'success');
                    setAllPriceData({
                        state: response.data.statedata || [],
                        distributor: response.data.distributordata || []
                    });
                    handleCloseEditModal();
                } else {
                    showToast(response.data.message, 'error');
                }

            } catch (err) {
                StopLoading(setisLoading);
                if (err.response?.status === 401) {
                    // Handle unauthorized
                } else {
                    showToast(err.response?.data?.message || "Failed to add Price List, please try again later", 'error');
                }
            }
        }
    };


    return {
        users,
        search,
        setSearch,
        isDisabled,
        filteredData, // Changed from filteredPriceList to filteredData
        isLoading,
        getPriceList,
        
        values, setvalue,
        handleChange,
        showEditPriceListModal,
        setShowEditPriceListModal,
        handleShowEditModal,
        handleCloseEditModal,
        
        
        priceListType,
        setPriceListType,
        allPriceData, // Added to return allPriceData if needed
        handleChange, countryData, stateData,  distributors,
        // handleVariantChange, handleProductChange, 
        products, productVariants, deletePriceList, handleProductPriceListSubmit
    }
}

export default MidPriceList;